/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Somethingwentwrongdescription3Inputs */

const en_common_error_somethingwentwrongdescription3 = /** @type {(inputs: Common_Error_Somethingwentwrongdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're having trouble loading this page.`)
};

/**
* | output |
* | --- |
* | "We're having trouble loading this page." |
*
* @param {Common_Error_Somethingwentwrongdescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_error_somethingwentwrongdescription3 = /** @type {((inputs?: Common_Error_Somethingwentwrongdescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Somethingwentwrongdescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_error_somethingwentwrongdescription3(inputs)
});
export { common_error_somethingwentwrongdescription3 as "common_error_somethingWentWrongDescription" }